module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_7042.fb524d9b.png";